import React, {useEffect, useState} from 'react'

function LogoCard({logoUrl}) {
    const [logo, setLogo] = useState(logoUrl)
    useEffect(() => {
        console.log(logoUrl)
        setLogo(logoUrl)
    }, [logoUrl])

    return (
        <div className="card card-padding shadow-none card-border">
            <div className="card-title">
                <div className="d-flex justify-content-between align-items-center">
                    <div><i className='bi bi-card-image'></i> Logo</div>
                </div>
            </div>
            <hr/>
            <div className="card-body">
                <img src={logoUrl} className='img-fluid' alt={logoUrl}/>
            </div>
        </div>

    )
}

export default LogoCard